import { StarterArticles, StarterArticleSource } from '../../../../types/StarterGuideTypes';

export const articles: StarterArticles = {
  title: 'Learn More',
  articles: [
    {
      title: 'What to Do When Your Puppy Whines in Their Crate',
      image:
        '/sites/default/files/styles/additional_slideshows_281_192/public/chocolate-labrador-puppy-in-wire-crate-with-paw-on-door-closeup-7-picture-id889008474.jpg',
      link: '/dog/training/what-do-when-your-puppy-whines-his-crate',
      source: StarterArticleSource.PET_MD,
    },
    {
      title: 'How to Get a Puppy to Sleep Through the Night',
      image:
        '/wp-content/uploads/2017/02/02152910/how-to-get-a-puppy-to-sleep-through-the-night-300x160.jpg',
      link: '/how-to-teach-your-puppy-to-sleep-through-the-night/',
      source: StarterArticleSource.BE_CHEWY,
    },
    {
      title: 'Proper Puppy Socialization for Greeting Other Dogs',
      image: '/wp-content/uploads/2019/07/24160341/proper-puppy-greeting-HERO-300x169.jpg',
      link: '/positively-trained-proper-puppy-socialization-for-greeting-other-dogs/',
      source: StarterArticleSource.BE_CHEWY,
    },
  ],
};
